import { Sk } from './shared';

const LINES = [
  { no: '21', lv: 'i',   t: 'GET /api/orders 200 14ms',  err: false },
  { no: '22', lv: 'i',   t: 'cache hit · region=eu-1',    err: false },
  { no: '23', lv: 'w',   t: 'retry queue depth 142',      err: false },
  { no: '24', lv: 'err', t: 'ECONNRESET pool exhausted',  err: true  },
  { no: '25', lv: 'i',   t: 'worker 3 reconnected',       err: false },
];

export function MkLogs() {
  return (
    <div className="csmk csmk-logs">
      <div className="logs">
        {LINES.map((l, i) => (
          <div className={`ln${l.err ? ' err' : ''}`} key={i}>
            <span className="no">{l.no}</span>
            <span className={`lv ${l.lv}`}>{l.lv === 'err' ? 'ERR' : l.lv === 'w' ? 'WRN' : 'INF'}</span>
            <span>{l.t}</span>
          </div>
        ))}
      </div>
      <div className="insight">
        <div className="h"><span className="spark" /> AI Insight</div>
        <div className="card-i">
          <span className="tag-i">ANOMALY · 1.2×</span>
          <span className="t">Connection pool saturated — spikes precede 5xx by ~40s.</span>
          <Sk w="60%" h="5px" />
        </div>
      </div>
    </div>
  );
}
